
/* styles */
require("!!../../node_modules/.2.1.0@extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/.10.3.0@vue-loader/lib/style-rewriter?id=data-v-80952dc8!../../node_modules/.10.3.0@vue-loader/lib/selector?type=styles&index=0!./List.vue")

var Component = require("!../../node_modules/.10.3.0@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/.10.3.0@vue-loader/lib/selector?type=script&index=0!./List.vue"),
  /* template */
  require("!!../../node_modules/.10.3.0@vue-loader/lib/template-compiler?id=data-v-80952dc8!../../node_modules/.10.3.0@vue-loader/lib/selector?type=template&index=0!./List.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/List.vue
// module id = 24
// module chunks = 0